export default {
  noteText: {
    type: 'string',
    required: true,
    maxSize: 65000,
  },
  attachmentPaths: {
    type: 'array',
    required: false,
  },
};
